import _styled from '@emotion/styled/base';
import { COLORS } from '@tablekit/theme';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

var SvgSymbolBase = function SvgSymbolBase(_ref) {
  var className = _ref.className;
  return jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.3 58.4",
    className: className,
    children: jsxs("g", {
      transform: "translate(0 3)",
      children: [jsx("path", {
        fill: "currentColor",
        d: "M0 37.7c1.5 3.9 3.9 7.5 7 10.7 3.1 3.1 6.8 5.5 10.7 7L28.1 45c-4.5-.2-8.8-2.1-12.2-5.5s-5.2-7.8-5.5-12.2L0 37.7"
      }), jsx("path", {
        fill: "currentColor",
        d: "M58.3 37.7c-1.5 3.9-3.9 7.5-7 10.7-3.1 3.1-6.8 5.5-10.7 7L30.2 45c4.5-.2 8.8-2.1 12.2-5.5s5.2-7.8 5.5-12.2l10.4 10.4"
      }), jsx("path", {
        fill: "currentColor",
        d: "M40.6-3c3.9 1.5 7.5 3.9 10.7 7 3.1 3.1 5.5 6.8 7 10.7L47.9 25.2c-.2-4.5-2.1-8.8-5.5-12.2s-7.8-5.2-12.2-5.5l1.7-1.7L40.6-3"
      }), jsx("path", {
        fill: "currentColor",
        d: "M17.7-3C13.8-1.5 10.2.9 7 4c-3.1 3.1-5.5 6.8-7 10.7l10.4 10.5c.2-4.5 2.1-8.8 5.5-12.2s7.8-5.2 12.2-5.5L17.7-3"
      })]
    })
  });
};

var LogoSymbol = /*#__PURE__*/_styled(SvgSymbolBase, process.env.NODE_ENV === "production" ? {
  target: "ejl5mgj0"
} : {
  target: "ejl5mgj0",
  label: "LogoSymbol"
})("width:", function (_ref2) {
  var size = _ref2.size;
  return size;
}, ";height:", function (_ref3) {
  var size = _ref3.size;
  return size;
}, ";color:", function (_ref4) {
  var isDarkTheme = _ref4.isDarkTheme,
      theme = _ref4.theme;
  var isDark = typeof isDarkTheme === 'undefined' ? theme === null || theme === void 0 ? void 0 : theme.isDark : isDarkTheme;
  return isDark ? 'white' : COLORS.PURPLE.L5;
}, ";");

export { LogoSymbol };
